const NODES = [
  [40, 60], [120, 30], [210, 70], [320, 40], [370, 110],
  [60, 180], [160, 150], [280, 170], [350, 230], [90, 290],
  [200, 320], [310, 300], [140, 380], [260, 390],
];
const EDGES = [
  [0, 1], [1, 2], [2, 3], [3, 4], [2, 6], [5, 6], [6, 7], [7, 8],
  [5, 9], [9, 10], [10, 11], [8, 11], [9, 12], [10, 13], [12, 13], [7, 4],
];

const NAME_SIZE = { sm: "text-[0px]", md: "text-lg sm:text-xl", lg: "text-2xl sm:text-3xl" };

export default function ProductVisual({ name, format, tag, size = "md", badgeTestId, className = "" }) {
  const formatLabel =
    format === "pen" ? "PEN KIT" : format === "raw" ? "RAW VIAL" : format === "bundle" ? "BUNDLE" : null;

  return (
    <div
      className={`relative flex h-full w-full flex-col items-center justify-center overflow-hidden bg-navy ${className}`}
      data-testid="product-visual"
    >
      <div
        className="absolute inset-0"
        style={{
          backgroundImage: "radial-gradient(rgba(255,255,255,0.10) 1px, transparent 1px)",
          backgroundSize: "22px 22px",
        }}
      />
      <svg className="absolute inset-0 h-full w-full opacity-[0.18]" viewBox="0 0 400 420" preserveAspectRatio="xMidYMid slice" aria-hidden="true">
        {EDGES.map(([a, b], i) => (
          <line key={i} x1={NODES[a][0]} y1={NODES[a][1]} x2={NODES[b][0]} y2={NODES[b][1]} stroke="#FFFFFF" strokeWidth="0.7" />
        ))}
        {NODES.map(([x, y], i) => (
          <circle key={i} cx={x} cy={y} r="2.2" fill="#1D4ED8" />
        ))}
      </svg>

      {size === "sm" ? (
        <span className="relative z-10 flex h-6 w-6 items-center justify-center rounded-md bg-brandblue">
          <span className="block h-2.5 w-2.5 rounded-full bg-white" />
        </span>
      ) : (
        <>
          <span className="absolute left-3 top-3 z-10 flex h-6 w-6 items-center justify-center rounded-md bg-brandblue">
            <span className="block h-2.5 w-2.5 rounded-full bg-white" />
          </span>
          <p className={`relative z-10 px-6 text-center font-heading font-black uppercase leading-tight text-white ${NAME_SIZE[size]}`}>
            {name}
          </p>
          {formatLabel && (
            <p className="relative z-10 mt-2.5 rounded-full border border-white/25 px-3 py-1 font-mono text-[10px] tracking-[0.25em] text-white/80" data-testid={badgeTestId}>
              {formatLabel}
            </p>
          )}
        </>
      )}

      {tag && (
        <span className="absolute bottom-3 right-3 z-10 font-mono text-[9px] tracking-[0.22em] text-white/50">
          {tag}
        </span>
      )}
    </div>
  );
}
